module.exports = __webpack_public_path__ + "img/video.78ac5dc1.svg";